export const RECORD_SOURCES = {
  THIS_RECORD: 'this_record',
  RELATED_OBJECT_FIELD: 'related_object_field',
  AUTOMATION_VARIABLE: 'automation_variable',
  GLOBAL: 'global',
} as const;

export const ValueSourceOptions = {
  NONE: 'none',
  SPECIFIC_VALUE: 'specific_value',
  RELATED_OBJECT_FIELD: 'related_object_field',
  CONTEXT_ENTITY_FIELD: 'context_entity_field',
  AUTOMATION_VARIABLE: 'automation_variable',
  AUTOMATION_ENTITY_VARIABLE_FIELD: 'automation_entity_variable_field',
  BLANK: 'blank',
} as const;
